import useWorkflowDraft from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/useWorkflowDraft';
import CheckboxTile from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Shared/CheckboxTile';
import SectionCard from '@Guidelines/Component/SectionCard';
import * as React from 'react';

/** What conditions the opening of a new preparation of this group for the same dossier. */
const NextPreparationSection: React.FC = () => {
	const { draft, setDraft } = useWorkflowDraft();

	const handleChange = React.useCallback(
		(checked: boolean) => {
			setDraft((current) => current.setRequiresValidationBeforeNext(checked));
		},
		[setDraft],
	);

	return (
		<SectionCard
			title="Nouvelle préparation"
			description="Ce qui conditionne l'ouverture d'une nouvelle préparation de ce groupe pour un même dossier."
		>
			<CheckboxTile
				name="requiresValidationBeforeNext"
				label="Exiger la validation des documents de la préparation précédente"
				checked={draft.requiresValidationBeforeNext}
				onChange={handleChange}
			/>
		</SectionCard>
	);
};

export default NextPreparationSection;
